export const FETCH_ALL_ASSIGN_VEHICLE_REQUEST = 'FETCH_ALL_ASSIGN_VEHICLE_REQUEST'
export const FETCH_ALL_ASSIGN_VEHICLE_SUCCESS = 'FETCH_ALL_ASSIGN_VEHICLE_SUCCESS'
export const FETCH_ALL_ASSIGN_VEHICLE_FALIURE = 'FETCH_ALL_ASSIGN_VEHICLE_FALIURE'
